import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif;
    background-color: #121212;
    color: #FFFFFF;
    overflow-x: hidden;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #1E1E1E;
  }

  ::-webkit-scrollbar-thumb {
    background: #3D3D3D;
    border-radius: 6px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #4F46E5;
  }

  /* Form elements focus styling */
  button, input, textarea, select {
    font-family: inherit;
  }

  a {
    color: #4F46E5;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }

  /* Smooth transitions */
  a, button, input, textarea, select {
    transition: all 0.2s ease-in-out;
  }

  /* Remove focus outline for mouse users, keep for keyboard */
  :focus:not(:focus-visible) {
    outline: none;
  }

  :focus-visible {
    outline: 2px solid #4F46E5;
    outline-offset: 2px;
  }
`;

export default GlobalStyles;
